import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/locales'

export function getLocale(): string {
	if (typeof navigator !== 'undefined') {
		return navigator.language ?? navigator.languages?.[0] ?? 'en-US'
	}
	return 'en-US'
}

export function matchSupportedLanguage(navLang: string): SupportedLanguage | null {
	if ((SUPPORTED_LANGUAGES as readonly string[]).includes(navLang)) {
		return navLang as SupportedLanguage
	}
	const langOnly = navLang.split('-')[0]
	const match = SUPPORTED_LANGUAGES.find(l => l.startsWith(langOnly + '-'))
	return match ?? null
}
